<ms-scroll-adapter [msScrollSelectedInView]="active && getGroupMenuItemId(active)" [scrollSize]="200" [stretch]="false">
    <ul class="group-container" [class.card-container]="model.displayMode === VirtualCompetitionDisplayMode.Cards">
        @for (group of model.groups; track trackTabsBy(index, group); let index = $index) {
            <li
                class="group-item"
                [class.active]="group.active"
                [class.no-participants]="
                    model.displayMode === VirtualCompetitionDisplayMode.Cards && (!group.participants || !group.participants.length)
                "
                [attr.data-menu-item-id]="getGroupMenuItemId(group)">
                @if (group.url) {
                    <a [href]="group.url" (click)="selected($event, group)">
                        <ng-template
                            *ngTemplateOutlet="
                                model.displayMode === VirtualCompetitionDisplayMode.Pills ? pillTemplate : cardTemplate;
                                context: { $implicit: group }
                            " />
                        @if (showFavouritesToggle && group.canBeFavourited) {
                            <ms-favourite-league-toggle
                                class="favourite-icon"
                                [sport]="model.sportId"
                                [id]="group.favouriteId"
                                [name]="group.favouriteName"
                                [tracking]="{ source: 'Groups Carousel', position: index }"
                                [class.hidden]="!group.active && !group.isFavourite" />
                        }
                    </a>
                }
            </li>
        }
    </ul>
</ms-scroll-adapter>

<ng-template #pillTemplate let-group>
    <div class="pills-template">
        <div class="title pills">
            <span>{{ group.title }}</span>
        </div>
    </div>
</ng-template>

<ng-template #cardTemplate let-group>
    <div class="cards-template">
        <div class="title">
            <span>{{ group.title }}</span>
        </div>
        @if (group.participants && group.participants.length > 0) {
            <div class="cards-participants-container">
                @for (participant of group.participants; track participant.participantId) {
                    <div class="cards-participant-item">
                        <div class="participant-image">
                            <ms-tournament-groups-participants
                                [participantId]="participant.participantId"
                                [sportId]="model.sportId"
                                [imageType]="model.imageType" />
                        </div>
                        <div class="participant-code">{{ participant.code }}</div>
                    </div>
                }
            </div>
        }
    </div>
</ng-template>
